<template>
  <ul
    v-if="value || error"
    class="bg-danger-50 dark:bg-danger-100 p-4 text-sm text-danger-600 rounded-md"
  >
    <li v-if="error">{{ error }}</li>
    <template v-for="(errors, key) in value" :key="key">
      <template v-for="(error, index) in errors" :key="index">
        <li>{{ key }}: {{ error }}</li>
      </template>
    </template>
  </ul>
</template>

<script>
export default {
  props: {
    value: Object,
    error: String,
  },
};
</script>
